export const GithubVerificationPage = () => {
  return <></>;
};
